'use strict';
window.app = angular.module('app', ['ui.router', 'ui.utils', 'oc.lazyLoad', 'ngCookies', 'ui.bootstrap', 'ngRoute']).config(["$locationProvider", function ($locationProvider) {
  $locationProvider.hashPrefix('');
  $locationProvider.html5Mode(true);
}]).factory('httpRequestInterceptor', ["$q", "$location", "$cookieStore", "$rootScope", "$timeout", "$window", "$cookies", "$injector", function ($q, $location, $cookieStore, $rootScope, $timeout, $window, $cookies, $injector) {
  var canceler = $q.defer();
  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  }
  return {
    request: function (config) {
      return config;
    },
    response: function (response) {
      return response;
    },
    responseError: function (rejection) {
      if (false && rejection.status == 401 && typeof rejection.config.headers['no-redirect'] == "undefined") {
        Intercom('shutdown');
        var path = "/#/access/login";
        console.log("401 Response Error", rejection);
        path += "?redirUrl=" + encodeURIComponent($window.location.href);
        $window.location.href = path;
        $cookies.remove("auth");
      }
      if (rejection.status === 500) {
        FS.event('internalError', {
          message: rejection.data
        });
      }
      if (typeof posthog !== 'undefined') {
        posthog.capture('dealrInternalError', {
          message: rejection.data
        });
      }
      if (rejection.status === 504 && Raven) {
        Raven.captureMessage('Gateway Timeout', {
          level: 'warning',
          extra: {
            url: rejection.config.url,
            method: rejection.config.method,
            data: rejection.config.data
          }
        });
        rejection.data = "Gateway Timeout";
      }
      if (rejection.status === 400 && rejection.headers && typeof rejection.headers === 'function' && rejection.headers('x-accounting-status')) {
        var accountingStatus = rejection.headers('x-accounting-status');
        var fullPageLoaderShown = false;
        if ($rootScope.showFullPageLoader) {
          fullPageLoaderShown = true;
          $rootScope.showFullPageLoader = false;
        }
        if (accountingStatus === '703') {
          var config = rejection.config;
          if (config.headers['x-retry-transaction']) {
            config.headers['x-retry-transaction'] = 1 * config.headers['x-retry-transaction'] + 1;
          } else {
            config.headers['x-retry-transaction'] = 1;
          }
          return new Promise(function (res) {
            setTimeout(res, 2000);
          }).then(function () {
            return $injector.get('$http')(config);
          });
        } else {
          var modalInstance = $injector.get("$uibModal").open({
            templateUrl: '/dealer/views/accounting/modules/locked_bypass_modal.html',
            controller: function ($scope, $uibModalInstance, canMakeAdjustingTransaction, lockReason, firmLocked, $sce) {
              $scope.canMakeAdjustingTransaction = canMakeAdjustingTransaction;
              $scope.firmLocked = firmLocked;
              $scope.adjust = {
                make_adjustment: false,
                date: new Date()
              };
              if ($scope.firmLocked) {
                $scope.lockReason = "<h4 class='m-b-10 b-b fs-18 text-center bold'>TRANSACTION FIRM LOCKED</h4>" + lockReason;
              } else {
                $scope.lockReason = "<h4 class='m-b-10 b-b fs-18 text-center bold'>TRANSACTION LOCKED</h4>" + lockReason;
              }
              $scope.cancel = function () {
                $uibModalInstance.dismiss();
              };
              $scope.update = function () {
                $uibModalInstance.close($scope.adjust);
              };
            },
            size: 'md',
            resolve: {
              canMakeAdjustingTransaction: function () {
                return accountingStatus === '702' || accountingStatus === '704';
              },
              firmLocked: function () {
                return accountingStatus === '704';
              },
              lockReason: function () {
                return rejection.data;
              },
              deps: function ($ocLazyLoad) {
                return $ocLazyLoad.load(['assets/js/controllers/accounting/accounting.js']);
              }
            }
          });
          return modalInstance.result.then(function (adjust) {
            console.log('Making adjustment.');
            if (fullPageLoaderShown) {
              $rootScope.showFullPageLoader = true;
            }
            var config = rejection.config;
            if (adjust.make_adjustment) {
              if (!adjust.date) return $q.reject(rejection);
              config.headers['x-accounting-adjust-date'] = moment(adjust.date).format('YYYY-MM-DD');
            } else {
              config.headers['x-accounting-ignore-lock'] = 1;
            }
            return $injector.get('$http')(config);
          }, function () {
            (function (proxied) {
              window.alertProxied = true;
              window.alert = function () {
                return false;
              };
              $timeout(function () {
                window.alertProxied = false;
                window.alert = proxied;
              });
            })(window.alert);
            return $q.reject(rejection);
          });
        }
      } else if (rejection.status === 400 && rejection.headers && typeof rejection.headers === 'function' && rejection.headers('x-client-confirm-dialog') && (rejection.config && rejection.config.url || '').indexOf('/api/login') === -1) {
        var accountingStatus = rejection.headers('x-client-confirm-dialog');
        var fullPageLoaderShown = false;
        if ($rootScope.showFullPageLoader) {
          fullPageLoaderShown = true;
          $rootScope.showFullPageLoader = false;
        }
        var modalInstance = $injector.get("$uibModal").open({
          templateUrl: '/dealer/views/manage/client_confirm_dialog.html',
          controller: function ($scope, $uibModalInstance, options, $sce) {
            $scope.options = options;
            $scope.cancel = function () {
              $uibModalInstance.dismiss();
            };
            $scope.selectOption = function (option) {
              $uibModalInstance.close(option);
            };
          },
          size: 'md',
          resolve: {
            options: function () {
              return rejection.data.options;
            }
          }
        });
        return modalInstance.result.then(function (option) {
          console.log('Accepting confirm dialog.');
          if (fullPageLoaderShown) {
            $rootScope.showFullPageLoader = true;
          }
          var config = rejection.config;
          var confirmDialogData = {};
          if (config.headers['x-client-confirm-dialog']) {
            confirmDialogData = angular.fromJson(config.headers['x-client-confirm-dialog']);
          }
          confirmDialogData[rejection.data.type] = option;
          config.headers['x-client-confirm-dialog'] = angular.toJson(confirmDialogData);
          return $injector.get('$http')(config);
        }, function () {
          (function (proxied) {
            window.alertProxied = true;
            window.alert = function () {
              return false;
            };
            $timeout(function () {
              window.alertProxied = false;
              window.alert = proxied;
            });
          })(window.alert);
          return $q.reject(rejection);
        });
      } else if (rejection.status === 403 && rejection.headers && typeof rejection.headers === 'function' && rejection.headers('x-msa-required')) {
        if ($rootScope.openMsaAgreement) $rootScope.openMsaAgreement();
        return $q.reject(rejection);
      } else if (rejection.status === 400 && rejection.headers && typeof rejection.headers === 'function' && rejection.headers('x-legal-terms')) {
        var fullPageLoaderShown = false;
        if ($rootScope.showFullPageLoader) {
          fullPageLoaderShown = true;
          $rootScope.showFullPageLoader = false;
        }
        return new Promise(function (res, reject) {
          $rootScope.openLegalAgreement(rejection.headers('x-legal-terms'), function (declined) {
            if (declined) {
              (function (proxied) {
                window.alertProxied = true;
                window.alert = function () {
                  return false;
                };
                $timeout(function () {
                  window.alertProxied = false;
                  window.alert = proxied;
                }, 100);
              })(window.alert);
              res($q.reject(rejection));
            } else {
              var config = rejection.config;
              console.log('Accepting terms dialog.');
              if (fullPageLoaderShown) {
                $rootScope.showFullPageLoader = true;
              }
              res($injector.get('$http')(config));
            }
          });
        });
      }
      return $q.reject(rejection);
    }
  };
}]).config(["$httpProvider", function ($httpProvider) {
  $httpProvider.interceptors.push('httpRequestInterceptor');
}]).directive('customTemplate', ["$compile", "$sce", function ($compile, $sce) {
  return {
    restrict: 'A',
    replace: true,
    link: function (scope, element, attrs) {
      scope.$watch(attrs.customTemplate, function (html) {
        element[0].innerHTML = $sce.trustAsHtml(html);
        $compile(element.contents())(scope);
      });
    }
  };
}]);